import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Pane from 'components/Common/Pane'

const BaseDeparturesMessagePane = styled(Pane)`
  border-radius: ${props => props.theme.borderRadius.large};
  padding: ${rem(40)} ${rem(20)};

  ${mediaQueryUp.sm} {
    padding: ${rem(40)};
  }

  > * + * {
    margin-top: ${rem(24)};
  }
`

const DeparturesMessagePaneTitleContainer = styled.div`
  text-align: center;

  > * + * {
    margin-top: ${rem(8)};
  }
`

const DeparturesMessagePaneActionContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueryUp.sm} {
    flex-direction: row;
    justify-content: center;
  }
`

export default BaseDeparturesMessagePane

export { DeparturesMessagePaneTitleContainer, DeparturesMessagePaneActionContainer }
